var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconDel = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 3.99967H14.6666V5.33301H13.3333V13.9997C13.3333 14.1765 13.263 14.3461 13.138 14.4711C13.013 14.5961 12.8434 14.6663 12.6666 14.6663H3.33325C3.15644 14.6663 2.98687 14.5961 2.86185 14.4711C2.73682 14.3461 2.66659 14.1765 2.66659 13.9997V5.33301H1.33325V3.99967H4.66659V1.99967C4.66659 1.82286 4.73682 1.65329 4.86185 1.52827C4.98687 1.40325 5.15644 1.33301 5.33325 1.33301H10.6666C10.8434 1.33301 11.013 1.40325 11.138 1.52827C11.263 1.65329 11.3333 1.82286 11.3333 1.99967V3.99967ZM11.9999 5.33301H3.99992V13.333H11.9999V5.33301ZM5.99992 7.33301H7.33325V11.333H5.99992V7.33301ZM8.66659 7.33301H9.99992V11.333H8.66659V7.33301ZM5.99992 2.66634V3.99967H9.99992V2.66634H5.99992Z",
    fill: "black",
    fillOpacity: 0.85
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconDel.7b3d83b8.svg";
export { ForwardRef as ReactComponent };